export const REDUCER_NAME = 'transition'

export const COUNT_ABSOLUTE = 'countAbsolute'

export const COUNT_RELATIVE = 'countRelative'

export const COUNT_AGGREGATED_RELATIVE = 'countAggregatedRelative'

export const COUNT_AGGREGATED_ABSOLUTE = 'countAggregatedAbsolute'


export const MODE_LIST = [
    {
        id: COUNT_AGGREGATED_RELATIVE,
        value: 'percentage aggregated',
    },
    {
        id: COUNT_AGGREGATED_ABSOLUTE,
        value: 'absolute aggregated',
    },
    {
        id: COUNT_ABSOLUTE,
        value: 'absolute',
    },
    {
        id: COUNT_RELATIVE,
        value: 'percentage',
    },
]



// WEBPACK FOOTER //
// ./src/modules/analytics/state/transition/const.js